import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExportReport } from '../models/export-report.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ExportReportToFile } from '../requests/export-report-to-file.request';
import { ExportHTMLToPDFFile } from '../requests/export-html-to-pdf-file.request';
import { FileOption } from '../models/file-option.model';
import { FileExtensionEnum } from '../enums/file-extension.enum';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ReportExportationService {

  constructor(private http: HttpClient) { }

  exportReportToFile(obj: ExportReportToFile): Observable<ExportReport> {
    return this.http.post<ExportReport>(environment.apiUrl + 'api/report/export/exportreport', obj);
  }
  exportHTMLToPDFFile(obj: ExportHTMLToPDFFile): Observable<ExportReport> {
    return this.http.post<ExportReport>(environment.apiUrl + 'api/report/export/exporthtmltopdf', obj);
  }

  convertBase64ToBlob(b64Data: string, contentType: string, sliceSize: number = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const options: BlobPropertyBag = {type: `${contentType};charset=UTF-8`};

    const blob = new Blob(byteArrays, options);
    return blob;
  }

  binToString(array): string {
    let result = '';
    for (let i = 0; i < array.length; i++) {
      result += String.fromCharCode(parseInt(array[i], 2));
    }
    return result;
  }

  //#region Download

  downloadBlobFile(blob: Blob, fileName: string) {
    saveAs(blob, fileName);
  }

  downloadBase64File(b64Data: string, fileName: string, contentType: string) {
    const blob = this.convertBase64ToBlob(b64Data, contentType);
    this.downloadBlobFile(blob, fileName);
  }

  //#endregion

  //#region Print

  printBase64File(b64Data: string, contentType: string) {
    const blob = this.convertBase64ToBlob(b64Data, contentType);
    this.printFile(blob);
  }

  printFile(blob: Blob) {
    const fileURL = URL.createObjectURL(blob);
    const ifrm = document.createElement('iframe');
    ifrm.src = fileURL;

    ifrm.style.height = '0px';
    ifrm.style.width = '0px';
    ifrm.style.border = '0px';

    document.body.appendChild(ifrm);

    ifrm.onload = () => {
      ifrm.contentWindow.print();
      ifrm.focus();
    };

    ifrm.onblur = () => {
      ifrm.remove();
    };
  }

  //#endregion

  //#region Send Email

  //#endregion

  getExtensionsOptions(): Array<FileOption> {
    return [
      new FileOption('CSV', FileExtensionEnum.CSV, 'fas fa-file-csv'),
      new FileOption('TXT', FileExtensionEnum.TXT, 'fas fa-file-alt')
    ];
  }

  getAllExtensionsOptions(): Array<FileOption> {
    return [
      new FileOption('CSV', FileExtensionEnum.CSV, 'fas fa-file-csv'),
      new FileOption('TXT', FileExtensionEnum.TXT, 'fas fa-file-alt'),
      new FileOption('PDF', FileExtensionEnum.PDF, 'far fa-file-pdf'),
      new FileOption('XLS (Excel)', FileExtensionEnum.XLS, 'far fa-file-excel'),
      new FileOption('XLSX (Excel)', FileExtensionEnum.XLSX, 'far fa-file-excel'),
      new FileOption('DOC (Word)', FileExtensionEnum.DOC, 'far fa-file-word'),
      new FileOption('DOCX (Word)', FileExtensionEnum.DOCX, 'far fa-file-word'),
      new FileOption('HMTL', FileExtensionEnum.HTML, 'fab fa-html5'),
    ];
  }
}
